const passwordLength = (value) => {
  if (!value) {
    return false;
  }
  return value.length > 6;
};
export default passwordLength;
